import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  browserTracingIntegration,
  init as initSentry,
  replayIntegration,
} from '@sentry/angular';
import { BE_URI_DEV, BE_URI_PROD, isPreviewHostname } from '@ess/shared-utils';
import { appConfig } from './app/app.config';
import { RootComponent } from './app/root.component';

function isSentryEnabled(): boolean {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return false;
  }

  return !isPreviewHostname(hostname);
}

const sentryEnabled = isSentryEnabled();

const replayIntegrations =
  isDevMode() || !sentryEnabled
    ? []
    : [
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ];

initSentry({
  enabled: sentryEnabled,
  dsn: 'https://1e884fef9c6181f3df8f8bd0f720deff@o401493.ingest.us.sentry.io/4511022576041984',
  environment: isDevMode() ? 'development' : 'production',
  release: `essentee-ui@${__SENTRY_RELEASE__}`,
  sendDefaultPii: true,
  integrations: [browserTracingIntegration(), ...replayIntegrations],
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  tracesSampleRate: 0.5, //  Capture 50% of the transactions
  tracePropagationTargets: ['localhost', BE_URI_DEV, BE_URI_PROD],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: isDevMode() ? 0 : 1,
  enableLogs: true,
});

bootstrapApplication(RootComponent, appConfig).catch((error: unknown) =>
  console.error(error),
);
